export interface TimeSeriesClearActionArgs {
  hasActiveCuts: boolean;
  hasActiveSelection: boolean;
}

/**
 * Time series clear actions are hierarchical:
 * 1. Clear nested selection inside cut data.
 * 2. Clear cut data back to the full dataset.
 */
export function shouldClearActiveSelectionFirst(args: TimeSeriesClearActionArgs): boolean {
  return args.hasActiveCuts && args.hasActiveSelection;
}
